import {
  Avatar,
  Box,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { diasDeSemanaUtil, formatDNI, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allDocentesAction,
  oneDocentesAction,
  setActivoDocentesAction,
} from '../DocentesAction';
import { PARAMS_DOCENTES, SELECTS_DOCENTES } from '../DocentesReducer';

export function orderDias(dias) {
  const dEnum = {
    LUNES: 1,
    MARTES: 2,
    MIERCOLES: 3,
    JUEVES: 4,
    VIERNES: 5,
    SABADO: 6,
    DOMINGO: 7,
  };

  return [...dias].sort((a, b) => {
    return dEnum[a] - dEnum[b];
  });
}

const ListadoDocentes = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const [rows, setRows] = React.useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...docentesStore.params,
        idEntidad: entidadesStore.activo.id,
      };

      dispatch({ type: PARAMS_DOCENTES, payload });
      if (docentesStore.all && docentesStore.all.length === 0) {
        await allDocentesAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];

    docentesStore.all.forEach((el) => {
      const fullname = `${el.usuario.perfil.papellido} ${
        el.usuario.perfil.sapellido ?? ''
      } ${el.usuario.perfil.pnombre} ${el.usuario.perfil.snombre ?? ''}`;
      const dni = `${el.usuario.perfil.tipoDni}-${formatDNI(
        el.usuario.perfil.dni,
      )}`;
      let dias = null;
      if (el.diasClases?.dias) {
        dias = orderDias(el.diasClases.dias);
      }
      rowsData.push({
        ...el,
        dni,
        dias,
        nombre: {
          nombre: fullname,
          correo: el.usuario.correo,
        },
        correo: el.usuario.correo,
        foto: el.usuario.perfil.avatar,
        estatus: el.estatus.nombre,
        actions: el,
      });
    });
    setRows(rowsData);
  }, [docentesStore.all]);

  const _handleEditClick = async (id) => {
    const data = docentesStore.all.find((el) => el.id === id);
    await setActivoDocentesAction(dispatch, data);
    await oneDocentesAction(dispatch, id);
    history.push(ROUTES.panelDocentes.to);
  };

  const columns = [
    {
      name: CONST.ID,
      label: 'ID',
      options: {
        // display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value}
              sx={{ width: 50, height: 50, mr: 1 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '120px' }}>
              <NameComponent
              // onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value}
              </NameComponent>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: 'Nombres y apellidos',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <CopyToClipboard
                text={value.correo}
                onCopy={() => {
                  notify(`${value.correo} Copiado!`, {
                    vertical: 'bottom',
                  });
                }}
              >
                <Typography
                  color="initial"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '10px',
                    cursor: 'pointer',
                    '&:hover': {
                      color: blue[700],
                    },
                  }}
                >
                  {value.correo}
                </Typography>
              </CopyToClipboard>
            </>
          );
        },
      },
    },
    {
      name: CONST.dias.name,
      label: CONST.dias.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Stack direction="row" spacing={1}>
              {value.map((el) => {
                const xdd = diasDeSemanaUtil.find((dd) => dd.dia === el);
                return (
                  <Chip
                    label={xdd.abrev}
                    sx={{ backgroundColor: xdd.color, fontWeight: 'bold' }}
                    size="small"
                  />
                );
              })}
            </Stack>
          ) : (
            <Chip label="Sin asignar" color="error" size="small" />
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={
                  value === 'ACTIVO'
                    ? 'success'
                    : value === 'BLOQUEADO'
                    ? 'error'
                    : 'warning'
                }
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" sx={{ width: '60px' }}>
              <BotonComponent
                click={async () => {
                  await setActivoDocentesAction(dispatch, value);
                  await oneDocentesAction(dispatch, value.id);
                  history.push(ROUTES.panelDocentes.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />

              {/* <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  await setActivoDocentesAction(dispatch, value);
                  // setOpenModalDelete(true);
                }}
              /> */}
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    selectableRowsHideCheckboxes: false,
    rowSelectionModel: rowSelectionModel,
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      setRowSelectionModel(allRowsSelected);
      const selectedUsers = allRowsSelected.map(
        (row) => docentesStore.all[row.index],
      );
      dispatch({ type: SELECTS_DOCENTES, payload: selectedUsers });
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget isLoading={docentesStore.loadingAll} />
        <MUIDataTable
          title={`Listado de ${
            docentesStore.pagination?.totalItems ??
            docentesStore.all.length ??
            0
          } registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {/* <Grid item md={12}>
        <PaginationComponent
          loading={docentesStore.loadingAll}
          page={docentesStore.params.page}
          totalPage={docentesStore.meta.totalPages}
          notText
          onChange={async (event, page) => {
            const payload = {
              ...docentesStore.params,
              page,
            };
            dispatch({ type: PARAMS_DOCENTES, payload });
            await allDocentesAction(dispatch, payload);
          }}
        />
      </Grid> */}
    </Grid>
  );
};

export default ListadoDocentes;
